import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { services } from '../../../shared';
import { Button, Modal } from '../../shared';
import './case-complete.scss';
export var CompleteCase = function (_a) {
    var show = _a.show, societyName = _a.societyName, handleClose = _a.handleClose, setNoAuth = _a.setNoAuth;
    var _b = useParams(), caseId = _b.caseId, loanPurposeId = _b.loanPurposeId;
    var history = useHistory();
    var submit = function () {
        services
            .submitCase(Number(caseId), Number(loanPurposeId))
            .then(function (result) {
            if (result.status == 401) {
                setNoAuth(true);
                handleClose();
            }
            else
                history.push("/cases/case/".concat(caseId));
        })
            .finally(function () {
            handleClose();
        });
    };
    var mouseClick = function (event) {
        var _a;
        if (!((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.closest('modal-main-case'))) {
            document.removeEventListener('click', mouseClick);
            handleClose();
        }
    };
    return (React.createElement(Modal, { show: show, handleClose: handleClose, extendClass: "submit-case" },
        React.createElement("p", null,
            "Submit case to ",
            societyName,
            "?"),
        React.createElement("div", { className: "submit-buttons" },
            React.createElement(Button, { type: "button", variant: "primary", onClick: handleClose }, "No"),
            React.createElement(Button, { type: "submit", variant: "primary", onClick: submit }, "Yes"))));
};
